/* import __COLOCATED_TEMPLATE__ from './user.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type SearchEntry from 'volta/models/search-entry';
import type { PayloadUser } from 'volta/models/search-entry';

interface BvAppSearchEntryUserSignature {
  Args: {
    entry: SearchEntry<PayloadUser>;
  };
  Element: HTMLElement;
}

const BvAppSearchEntryUserComponent = templateOnlyComponent<BvAppSearchEntryUserSignature>();

export default BvAppSearchEntryUserComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::User': typeof BvAppSearchEntryUserComponent;
    'bv-app-search/entry/user': typeof BvAppSearchEntryUserComponent;
  }
}
